<template>
    <div class="mt-3">
        <experiences-elements
            v-for="xp in experiences"
            :key="xp.id"
            :id="xp.id"
            :name="xp.name"
            :elements="xp.elements"/>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import ExperiencesElements from '../components/experiences/experiencesElements'

export default {
    name: 'experiences',
    components: {ExperiencesElements},
    computed: {
        ...mapGetters({
            loaded: 'experiencesModule/isLoaded',
            jobs: 'experiencesModule/getJobs',
            projects: 'experiencesModule/getProjects',
            entrepreneurships: 'experiencesModule/getEntrepreneurships',
            internships: 'experiencesModule/getInternships'
        }),
        experiences () {
            return [
                {id: 'jobs', elements: this.jobs, name: ''},
                {id: 'projects', elements: this.projects, name: 'Projets'},
                {id: 'entrepreneurships', elements: this.entrepreneurships, name: 'Autoentrepreneur'},
                {id: 'internships', elements: this.internships, name: 'Stages'}
            ]
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.load()
        })
    },
    methods: {
        ...mapActions({
            load: 'experiencesModule/loadExperiences'
        })
    }
}
</script>

<style scoped lang="scss">
div {
    width: calc(100% - 58px) !important;
    margin: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/experiences.vue